import { Injector, Component, OnInit, HostBinding } from '@angular/core';
import { EventsComponent } from '../events/events.component';

@Component({
	selector: 'styled-buttons',
	template: `
		<span *ngIf="control" [ngClass]="{ error: error }"
			><fieldset>
				<styled-button
					[ngClass]="{ disabled: control.disabled }"
					*ngFor="let button of control.options"
					[control]="control"
					[context]="context"
					[attributes]="control.attributes"
					[parentName]="control.title"
					[selectedValue]="value"
					[value]="button.value"
					[Name]="control.name"
					[disabled]="control.disabled"
					(setAnswer)="setStyledButtonAnswer($event)"
					[title]="button.title"
				></styled-button>
			</fieldset>
		</span>
	`,
	styleUrls: ['./styled-buttons.component.scss'],
})
export class StyledButtonsComponent extends EventsComponent implements OnInit {
	@HostBinding('attr.name')
	name = this.control ? this.control.name : '';
	constructor(injector: Injector) {
		super(injector);
	}

	ngOnInit() {
		this.gaLabel = this.getGaLabel(this.control);
	}

	setStyledButtonAnswer(value) {
		this.setAnswer(value);
	}
}
